(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bymjm-collection-grid"]) return;
  try {
    
(function(){
  function bymjmKeepOnlyPrimaryFacets(root){
    root = root || document;
    var wrappers = root.querySelectorAll('#main-collection-filters details, #main-collection-filters .facets__disclosure, #main-collection-filters .mobile-facets__details');
    wrappers.forEach(function(group){
      var head = group.querySelector('summary, .facets__summary, .mobile-facets__summary, .facets__heading');
      if(!head) return;
      var txt = (head.textContent || '').trim().toLowerCase();
      var keep =
        txt.indexOf('boormaat') !== -1 ||
        txt.indexOf('boorafstand') !== -1 ||
        txt.indexOf('lochabstand') !== -1 ||
        txt.indexOf('hole spacing') !== -1 ||
        txt.indexOf('hartafstand') !== -1 ||
        txt.indexOf('gatfstand') !== -1 ||
        txt.indexOf('gatafstand') !== -1 ||
        txt.indexOf('kleur') !== -1 ||
        txt.indexOf('color') !== -1 ||
        txt.indexOf('farbe') !== -1;
      group.classList.toggle('bymjm-hidden-facet', !keep);
    });
  }

  function run(){ bymjmKeepOnlyPrimaryFacets(document); }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  }else{
    run();
  }

  var observer = new MutationObserver(function(mutations){
    for(var i=0;i<mutations.length;i++){
      if(mutations[i].addedNodes && mutations[i].addedNodes.length){
        run();
        break;
      }
    }
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bymjm-knoppen-grid-v1"]) return;
  try {
    
(function(){
  function bymjmKeepOnlyPrimaryFacets(root){
    root = root || document;
    var wrappers = root.querySelectorAll('#main-collection-filters details, #main-collection-filters .facets__disclosure, #main-collection-filters .mobile-facets__details');
    wrappers.forEach(function(group){
      var head = group.querySelector('summary, .facets__summary, .mobile-facets__summary, .facets__heading');
      if(!head) return;
      var txt = (head.textContent || '').trim().toLowerCase();
      var keep = txt.indexOf('kleur') !== -1 || txt.indexOf('color') !== -1 || txt.indexOf('farbe') !== -1;
      group.classList.toggle('bymjm-hidden-facet', !keep);
    });
  }

  function run(){ bymjmKeepOnlyPrimaryFacets(document); }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  }else{
    run();
  }

  var observer = new MutationObserver(function(mutations){
    for(var i=0;i<mutations.length;i++){
      if(mutations[i].addedNodes && mutations[i].addedNodes.length){
        run();
        break;
      }
    }
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
